import { createApp, ref, defineComponent } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import VueAxios from 'vue-axios'
import axios from 'axios'
// import VueElementLoading from 'vue-element-loading'
import { Modal, modalPlugin } from '@kouts/vue-modal'
import "vue3-toastify/dist/index.css";
import VueViewer from 'v-viewer'

import '@kouts/vue-modal/dist/vue-modal.css'
import store from './store'
import Root from './Root.vue'
import Top from './Top.vue'
import Register from './Register.vue'
import App from './App.vue'
import Play from './Play.vue'
import Account from './Account.vue'
import Email from './Email.vue'
import EmailAfter from './EmailAfter.vue'
import Google from './Google.vue'
import History from './History.vue'
import Reminder from './Reminder.vue'
import Password from './Password.vue'
import Help from './Help.vue'
import Withdraw from './Withdraw.vue'
//

const routes = [
  { name: 'Top', path: '/', component: Top },
  { name: 'App', path: '/:app', component: App },
  { name: 'Play', path: '/:app/play', component: Play },
  { name: 'Register', path: '/register', component: Register, props: { guest: true, redirect: { name: 'Account' } } },
  { name: 'Account', path: '/account', component: Account, props: { guest: false, redirect: { name: 'Top' } } },
  { name: 'Password', path: '/password', component: Password, props: { guest: false, redirect: { name: 'Top' } } },
  { name: 'Reminder', path: '/reminder', component: Reminder, props: { guest: true, redirect: { name: 'Password' } } },
  { name: 'Email', path: '/email', component: Email, props: { guest: false, redirect: { name: 'Top' } } },
  { name: 'EmailAfter', path: '/email/after', component: EmailAfter },
  { name: 'Google', path: '/google', component: Google, props: { guest: false, redirect: { name: 'Top' } } },
  { name: 'History', path: '/history', component: History, props: { guest: false, redirect: { name: 'Top' } } },
  { name: 'Help', path: '/help', component: Help },
  { name: 'Withdraw', path: '/withdraw', component: Withdraw, props: { guest: false, redirect: { name: 'Top' } } },
  // { name: 'MemberLogin', path: '/member/login', component: MemberLogin, props: { guest: true } },
  // { name: 'MemberRegister', path: '/member/register', component: MemberRegister, props: { guest: true } },
]

const routerHistory = createWebHistory('/p/')
const router = createRouter({
  history: routerHistory,
  routes: routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
})
const app = createApp(Root);
// app.directive('scroll', {
//   inserted: function (el, binding) {
//     let f = function (evt) {
//       if (binding.value(evt, el)) {
//         window.removeEventListener('scroll', f)
//       }
//     }
//     window.addEventListener('scroll', f)
//   }
// });
app.use(router);
app.use(store);
app.use(VueAxios, axios);
// app.use(VueViewer, {
//   debug: true,
// });
// import 'viewerjs/dist/viewer.css'
// app.component('VueElementLoading', VueElementLoading);
app.use(modalPlugin);
app.component('Modal', Modal)

import 'vue-loading-overlay/dist/css/index.css';
import LoadingOverlay from 'vue-loading-overlay';
app.component('LoadingOverlay', LoadingOverlay);

import LayoutHeader from './Layouts/Header.vue'
app.component('LayoutHeader', LayoutHeader);

import "./styles.scss"
app.mount('#app');
